import {
  Avatar,
  Badge,
  Box,
  FormLabel,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import Sheet from "@mui/joy/Sheet";
import Radio, { radioClasses } from "@mui/joy/Radio";
import RadioGroup from "@mui/joy/RadioGroup";
import saved from "../../assets/sound/saved.wav";
import { Add, CheckCircle, Refresh, Remove, Save } from "@mui/icons-material";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";

const MoveForm = ({ title, store, van, web, amazon, id, setOpenMove }) => {
  const [locationA, setLocationA] = useState("store");
  const [locationB, setLocationB] = useState("van");
  const [count, setCount] = useState(1);

  const handleImg = (props) => {
    switch (props.value) {
      case "store":
        return "https://firebasestorage.googleapis.com/v0/b/pydb-ce2bb.appspot.com/o/store.png?alt=media&token=3eb9f9f5-cbbb-44c0-9e2f-a93c13d6bacd";
      case "van":
        return "https://firebasestorage.googleapis.com/v0/b/pydb-ce2bb.appspot.com/o/van.png?alt=media&token=6fe6cd9d-5661-4c07-948b-c970dbd84c5e";
      case "web":
        return "https://firebasestorage.googleapis.com/v0/b/pydb-ce2bb.appspot.com/o/web.png?alt=media&token=590439c9-8de2-4c81-b533-354dc659364f";
      case "amazon":
        return "https://firebasestorage.googleapis.com/v0/b/pydb-ce2bb.appspot.com/o/amazon.png?alt=media&token=20143abb-5342-4a1a-a275-dc16d7b3fb75";
      default:
        return "";
    }
  };

  const handleStk = (props) => {
    switch (props.value) {
      case "store":
        return store;
      case "van":
        return van;
      case "web":
        return web;
      case "amazon":
        return amazon;
      default:
        return 0;
    }
  };

  const handleSave = () => {
    const userDoc = doc(db, "products", id);

    if (locationA === "store") {
      store = store - count;
      const field = { stock_store: store };
      updateDoc(userDoc, field);
    }
    if (locationA === "van") {
      van = van - count;
      const field = { stock_van: van };
      updateDoc(userDoc, field);
    }
    if (locationA === "web") {
      web = web - count;
      const field = { stock_var1: web };
      updateDoc(userDoc, field);
    }
    if (locationA === "amazon") {
      amazon = amazon - count;
      const field = { stock_var2: amazon };
      updateDoc(userDoc, field);
    }
    //=======
    if (locationB === "store") {
      store = store + count;
      const field = { stock_store: store };
      updateDoc(userDoc, field);
    }
    if (locationB === "van") {
      van = van + count;
      const field = { stock_van: van };
      updateDoc(userDoc, field);
    }
    if (locationB === "web") {
      web = web + count;
      const field = { stock_var1: web };
      updateDoc(userDoc, field);
    }
    if (locationB === "amazon") {
      amazon = amazon + count;
      const field = { stock_var2: amazon };
      updateDoc(userDoc, field);
    }
    new Audio(saved).play();
    setOpenMove(false);

    // window.location.reload();
  };

  const handleAdd = () => {
    const newv = count + 1;
    setCount(newv);
  };

  const handleReset = () => {
    setCount(1);
  };

  const handleLess = () => {
    const newv = count - 1;
    setCount(newv);
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={1} sm={12}>
        <Typography variant="h6" sx={{ color: "purple" }}>
          {title}
        </Typography>
      </Grid>
      <Box padding={1.5}>
        <Grid item xs={12} sm={4}>
          <Box sx={{ display: "flex", gap: 6 }}>
            <RadioGroup
              aria-label="platform"
              defaultValue="store"
              overlay
              name="platform"
              sx={{
                flexDirection: "row",
                gap: 2,
                [`& .${radioClasses.checked}`]: {
                  [`& .${radioClasses.action}`]: {
                    inset: -1,
                    border: "3px solid",
                    borderColor: "primary.500",
                  },
                },
                [`& .${radioClasses.radio}`]: {
                  display: "contents",
                  "& > svg": {
                    zIndex: 2,
                    position: "absolute",
                    top: "-8px",
                    right: "-8px",
                    bgcolor: "background.body",
                    borderRadius: "50%",
                  },
                },
              }}
            >
              {["store", "van", "web", "amazon"].map((value) => (
                <Sheet
                  key={value}
                  variant="outlined"
                  sx={{
                    borderRadius: "md",
                    bgcolor: "background.body",
                    boxShadow: "sm",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 1.5,
                    p: 2,
                    minWidth: 120,
                  }}
                >
                  <Radio
                    id={value}
                    value={value}
                    onChange={(e) => setLocationA(e.target.value)}
                    checkedIcon={<CheckCircle />}
                  />
                  <Badge badgeContent={handleStk({ value })}>
                    <Avatar
                      variant="soft"
                      size="sm"
                      src={handleImg({ value })}
                    />
                  </Badge>
                  <FormLabel htmlFor={value}>{value}</FormLabel>
                </Sheet>
              ))}
            </RadioGroup>
          </Box>
        </Grid>
      </Box>
      <Box padding={1.5}>
        <Grid item xs={12} sm={4}>
          <Box sx={{ display: "flex", gap: 6 }}>
            <RadioGroup
              aria-label="platform"
              defaultValue="van"
              overlay
              name="platform"
              sx={{
                flexDirection: "row",
                gap: 2,
                [`& .${radioClasses.checked}`]: {
                  [`& .${radioClasses.action}`]: {
                    inset: -1,
                    border: "3px solid",
                    borderColor: "primary.500",
                  },
                },
                [`& .${radioClasses.radio}`]: {
                  display: "contents",
                  "& > svg": {
                    zIndex: 2,
                    position: "absolute",
                    top: "-8px",
                    right: "-8px",
                    bgcolor: "background.body",
                    borderRadius: "50%",
                  },
                },
              }}
            >
              {["store", "van", "web", "amazon"].map((value) => (
                <Sheet
                  key={value}
                  variant="outlined"
                  sx={{
                    borderRadius: "md",
                    bgcolor: "background.body",
                    boxShadow: "sm",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 1.5,
                    p: 2,
                    minWidth: 120,
                  }}
                >
                  <Radio
                    id={value}
                    value={value}
                    onChange={(e) => setLocationB(e.target.value)}
                    checkedIcon={<CheckCircle />}
                  />
                  <Badge badgeContent={handleStk({ value })}>
                    <Avatar
                      variant="soft"
                      size="sm"
                      src={handleImg({ value })}
                    />
                  </Badge>
                  <FormLabel htmlFor={value}>{value}</FormLabel>
                </Sheet>
              ))}
            </RadioGroup>
          </Box>

          <Box
            display="flex"
            width={500}
            height={200}
            alignItems="center"
            justifyContent="center"
          >
            <IconButton variant="soft" onClick={handleReset}>
              <Refresh
                sx={{
                  background: "gray",
                  color: "white",
                  borderRadius: "50%",
                  height: "60px",
                  width: "60px",
                }}
              />
            </IconButton>
            <IconButton variant="soft" onClick={handleLess}>
              <Remove
                sx={{
                  background: "red",
                  color: "white",
                  borderRadius: "50%",
                  height: "80px",
                  width: "80px",
                }}
              />
            </IconButton>
            <Typography variant="h1">{count}</Typography>
            <IconButton variant="soft" onClick={handleAdd}>
              <Add
                sx={{
                  background: "green",
                  color: "white",
                  borderRadius: "50%",
                  height: "80px",
                  width: "80px",
                }}
              />
            </IconButton>
            <IconButton variant="soft" onClick={handleSave}>
              <Save
                sx={{
                  color: "gray",
                  height: "60px",
                  width: "60px",
                }}
              />
            </IconButton>
          </Box>
        </Grid>
      </Box>
    </Grid>
  );
};

export default MoveForm;
